import { render } from "./DireccionesList.vue?vue&type=template&id=0a811e12"
import script from "./DireccionesList.vue?vue&type=script&lang=js"
export * from "./DireccionesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__